/**
 * O que faz: entrega a página autenticada de retornos programados da equipe.
 * Onde usa: rota protegida /retornos dentro do MainLayout.
 * Conexões: ReturnsBoard.
 * Tabelas: Nenhuma; o board consome os hooks da feature de retornos.
 * Data: 24/08/2026
 */

import { ReturnsBoard } from '@/features/returns/ReturnsBoard';

export default function ReturnsPage() {
  return <ReturnsBoard />;
}
